export default {
    state: {
        //电梯实时数据
        realData: null, //999101,实时数据
        signalData: null, //999102，信号点
        //设备调试--指令
        commandResult: null, //999103指令返回结果
        firmwareHistoryList: null, //999104固件升级列表
        firmwareHistoryDetail: null, //999105固件升级详情


    },
    mutations: {
        //电梯实时数据
        CHANGE_REALDATA: (state, newVal) => {
            state.realData = newVal ? JSON.parse(JSON.stringify(newVal)) : null;
        },
        CHANGE_SIGNALdATA: (state, newVal) => {
            state.signalData = newVal ? newVal : null;
        },
        //设备调试--指令
        CHANGE_COMMANDRESULT: (state, newVal) => {
            state.commandResult = newVal ? newVal : null;
        },
        CHANGEFIRMWAREHISTORYLIST: (state, newVal) => {
            state.firmwareHistoryList = newVal ? newVal : null;
        },
        //更改固件详情
        CHANGEFIRMWAREHISTORYDETAIL: (state, newVal) => {
            state.firmwareHistoryDetail = newVal ? newVal : null;
        },

    },
    actions: {
        //电梯实时数据
        changeRealData: ({ commit, state }, realData) => {
            commit('CHANGE_REALDATA', realData)
        },
        changeSignalData: ({ commit, state }, signalData) => {
            commit('CHANGE_SIGNALdATA', signalData)
        },
        //设备调试--指令
        changeCommandResult: ({ commit, state }, commandResult) => {
            commit('CHANGE_COMMANDRESULT', commandResult)
        },
        //更改固件列表04
        changeFirmwareHistoryList: ({ commit, state }, firmwareHistoryList) => {
            commit('CHANGEFIRMWAREHISTORYLIST', firmwareHistoryList)
        },
        //更改固件详情05
        changefirmwareDetail: ({ commit, state }, firmwareDetail) => {
            commit('CHANGEFIRMWAREHISTORYDETAIL', firmwareDetail)
        },

    },
}


// WEBPACK FOOTER //
// ./src/store/modules/realTimeData.js